module.exports = __webpack_public_path__ + "static/media/buy_start_service_make_2.8dd33ed1.jpg";